import React, { useState } from 'react';
import Data from './destination.json';
import './destination.css';
import { SlLocationPin } from 'react-icons/sl';



const Destination = () => {
  const [categoryFilter, setCategoryFilter] = useState('');

  const uniqueCategories = ['All', ...new Set(Data.map(destination => destination.location))];

  const filteredData = categoryFilter && categoryFilter !== 'All'
    ? Data.filter(destination => destination.location === categoryFilter)
    : Data;

  return (
    <section className="section destination">
      <article className="destination__content">
        <h1>Choose Your Destination</h1>
        <div className="filter-list">
          {uniqueCategories.map(category => (
            <button
              key={category}
              onClick={() => setCategoryFilter(category)}
              className={category === categoryFilter ? 'active' : ''}
            >
              {category}
            </button>
          ))}
        </div>
      </article>

      <article className="cards__destination grid flex">
      

        
        {filteredData.map(destination => (
          <div key={destination.id} className="card__destination">
              <img src={destination.imgSrc} alt={destination.destTitle} />
              
              <div className="destination__data">
                <h3>{destination.destTitle}</h3>

                <div className="destination__detail flex">
                  <SlLocationPin className='location'/>
                  <p>{destination.location}</p>
                  <span>{destination.grade}</span>
                </div>
              
                <div className="destiantion__btn flex">
                <button className="see-map">
                  <a href={destination.map}>
                    <span className="circle" aria-hidden="true">
                    <span className="icon arrow"></span>
                    </span>
                    <p className="button-text">See for location</p>
                  </a>
                </button>
                  <span className='destination__fees'>{destination.fees}</span>
                </div>
              </div>
          </div>
        ))}
      </article>
    </section>
  );
};

export default Destination;
